import * as React from 'react';
import './style/index.css';

import { Route, Link, Switch, BrowserRouter as Router, useLocation } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';

import NavBar from './inc/NavBar';
import Footer from './inc/Footer';
import { Provider, connect, useSelector, useDispatch } from 'react-redux';
import * as actions from './redux/actions'
import { createStore } from 'redux'
import { PersistGate } from 'redux-persist/integration/react'

import store, { persistor } from './redux/store';

//import Job from './screens/jobs/Job';
import Financials from './screens/Financials/Financials'
import Job from './screens/jobs/NewJob/Job'

//import { Job as NewJob } from './screens/jobs/NewJob/Job'

import Ads from './ads/Ads'
import AccountingChartOfAccounts from './accounting/AccountingChartOfAccounts'
import NotFound from './screens/Notfound/Notfound';
import GenericInventory from './screens/jobs/GenericInventory';

import config from './constants/config'


import ClientsScreen from './screens/ClientsScreen/ClientsScreen';
import ClientProfile from './screens/ClientsScreen/ClientProfile';
import TwilioDialer from './screens/TwilioDialer/TwilioDialer';
import Workers from './screens/WorkersScreen/Workers'
import PrivateRoute from './screens/routes/PrivateRoute';
import Equipment from './screens/Equipment/Equipment'
import Settings from './screens/Settings/Settings'
import WorkerProfile from './screens/WorkersScreen/WorkerProfile'
import NewWorker from './screens/WorkersScreen/NewWorker'
import Jobs from './screens/jobs/JobsScreen/Jobs'
import QuoteScreen from './screens/QuoteScreen/QuoteScreen'
import UserAgreement from './screens/RegisterScreen/UserAgreement'
import WorkerDev from './screens/WorkerDev/WorkerDev'

import Accounting from './screens/accounting/Accounting'

import Booking from './screens/Plugin_Booking/Booking'
// import Booking_1 from './screens/Plugin_Booking/Old_Booking_1'
import toast, { Toaster } from 'react-hot-toast';
import CompanyProfile from './screens/CompanyProfile/CompanyProfile';
import FrontEnd from './FrontEnd';
import Home from './Home'
import RegisterScreen from './screens/RegisterScreen/RegisterScreen';

import DarkTheme from './constants/Theme/dark'
import DefaultTheme from './constants/Theme/default'
import SettingsContext from './constants/Theme/Settings/SettingsContext';
import SettingsProvider from './constants/Theme/Settings/SettingsProvider';
import CssBaseline from '@mui/material/CssBaseline';

import { useMediaQuery } from '@mui/material';
// import { ThemeProvider} from '@mui/styles'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { IAppState } from './redux/reducers';
import ForgotPassword from './screens/ForgotPassword/ForgotPassword';
import ResetChangePassword from './screens/ForgotPassword/ResetChangePassword';

import PrivacyPolicy from './components/Agreements/PrivacyPolicy'
import PublicRoute from './screens/routes/PublicRoute';
import JobDispute from './screens/jobs/JobDispute/JobDispute';


function noop() { }

if (!import.meta.env.VITE_ENABLED_DEBUG || import.meta.env.VITE_ENABLED_DEBUG == "false") {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}


const Screens = (props) => {
  // console.log(console.log('Route: ' + useLocation().pathname))
  let auth = useSelector((state: IAppState) => state.auth)
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(actions.InitAuth())
  }, [])

  const logout = async () => {
    dispatch(actions.logOut())
  }

  return (
    <div>
      <div className={"content-wrap"}>
        <NavBar logout={logout} />
        {/* modal TwilioDialer */}
        {auth.token && <TwilioDialer {...props} />}

        <Switch>
          <PublicRoute exact token={auth.token} path="/">
            <FrontEnd />
          </PublicRoute>
          {/* <Route exact path="/" component={FrontEnd} /> */}
          <Route path="/login" component={LoginScreen} />
          <Route path="/register" component={RegisterScreen} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/change-password" component={ResetChangePassword} />
          <Route path="/terms" component={UserAgreement} />
          <Route path="/privacy" component={PrivacyPolicy} />

          <Route exact path="/job/:job_id/dispute/:token" component={JobDispute} />

          <PrivateRoute token={auth.token} path='/financials' component={Financials} />
          <PrivateRoute token={auth.token} path='/equipment' component={Equipment} />
          <PrivateRoute token={auth.token} path="/jobs" component={/*JobsScreen*/Jobs} />
          <PrivateRoute token={auth.token} path="/job/:job_id" component={Job /*Job*/} />
          <PrivateRoute token={auth.token} path="/settings" component={Settings} />
          <PrivateRoute token={auth.token} path="/worker-dev" component={WorkerDev} />

          <PrivateRoute token={auth.token} path="/ads" component={Ads} />
          <PrivateRoute token={auth.token} path="/accounting" component={Accounting} />
          <PrivateRoute token={auth.token} path="/accounting-chart-of-accounts" component={AccountingChartOfAccounts} />
          <PrivateRoute token={auth.token} path="/GenericInventory" component={GenericInventory} />
          <PrivateRoute token={auth.token} path="/workers/new-worker" exact={true} component={NewWorker} />
          <PrivateRoute token={auth.token} path="/workers" component={Workers} />

          <PrivateRoute token={auth.token} path="/worker/:id" component={/*WorkerScreen*/WorkerProfile} />
          <PrivateRoute token={auth.token} path="/worker/:id/:new-worker" component={/*WorkerScreen*/WorkerProfile} />
          <PrivateRoute token={auth.token} path="/clients" component={ClientsScreen} />
          {/* <PrivateRoute token={auth.token} path="/clients/:page"  exact={true} component={ClientsScreen} /> */}
          <PrivateRoute token={auth.token} path="/client/:id" component={ClientProfile} />


          {/* <PrivateRoute token={auth.token}
                                path="/documents/:entity/folders/:id"
                                component={Folders} /> */}

          {/* {_renderComponentAuth()} */}

          {/* <Route path="/job/:job_id/:job_super_type" exact  component={Job} /> */}
          <Route exact path="/:companyHandle" component={CompanyProfile} />
          <Route path="*" component={NotFound} />

        </Switch>
      </div>

      <Footer />
    </div>
  )
}


const InitApp = (props) => {

  return (
    <Router>
      <>
        <div className={""}>
          <div className="">
            <Switch>
              <Route exact path="/quote/:token" component={QuoteScreen} />
              {/* <Route exact path="/booking" component={Booking_1} /> */}
              <Route exact path="/booking/:token" component={Booking} />

              <Screens {...props} />
            </Switch>
          </div>
        </div>
      </>
    </Router>
  )
}





// const generateClassName = createGenerateClassName({
//     productionPrefix: 'c',
// });
const RootApp = (): JSX.Element => {

  // console.log("prefersDarkMode", prefersDarkMode)
  const context = React.useContext(SettingsContext);
  // console.log("context", context)
  const theme = context.darkMode ? DarkTheme : DefaultTheme;
  // console.log("themeee",theme)
  return (
    // <StylesProvider generateClassName={generateClassName} >
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <InitApp />
    </ThemeProvider>
    // </StylesProvider>
  )
}
// use for production
export const App = () => {
  return (

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <SnackbarProvider maxSnack={3} > */}
        <SettingsProvider>
          <RootApp />
          <Toaster />
        </SettingsProvider>
        {/* </SnackbarProvider> */}
      </PersistGate>
    </Provider>
  )
};

// use for development
export default App;

